import React from "react";
import PropTypes from "prop-types";

const WidgetOverlayLinkToTa = ({ buttonText, taUrl }) => {
  return (
      <div className="overlay overlay-default">
          <a href={taUrl} className="btn" target="_blank">
              {buttonText}
          </a>

    </div>
  );
};

WidgetOverlayLinkToTa.propTypes = {
    buttonText: PropTypes.string.isRequired,
    taUrl: PropTypes.string.isRequired
};

export default WidgetOverlayLinkToTa;



// WEBPACK FOOTER //
// ./src/dashboard/widgets/WidgetOverlayLinkToTa.js